AoPS.Utils.initKeyChain(AoPS, "Alcumus", "Views", "Subject");

AoPS.Alcumus.Views.Subject = (function (AlcVSubject) {
	// Dependencies
	var AlcVBase = AoPS.Alcumus.Views.Base;
	// Optional and allowed to load before or after this file
	// AoPS.Alcumus.Debug;

	AlcVSubject.XpBar = AlcVBase.BaseView.extend({
		// [r, g, b] 0-255 format
		dark_bar_color: [31, 61, 123], // Resources blue #1f3d7b
		light_bar_color: [131, 161, 214], // Resources text #83a1d6

		initialize: function (options) {
			this.setTemplateAndUseRootEl("alc-tpl-xp-bar");

			this.color_class_list = options.color_class_list;
			this.color_level_list = options.color_level_list;

			this.listenTo(this.model, "change", this.render);
			this.render();
		},

		getContext: function () {
			var level = this.model.get("level");
			var xp_in_level = this.model.get("xp_in_level");
			if (this.model.get("xp_percent") >= 100 && xp_in_level <= 0) {
				xp_in_level = "";
			}
			return {
				name: this.model.get("name"),
				level: level,
				color: this.computeShieldColor(level),
				xp_in_level: xp_in_level,
				xp_to_next: this.model.get("xp_to_next"),
			};
		},

		computeShieldColor: function (level) {
			level = parseInt(level, 10);
			if (level >= 19) {
				return "blue";
			} else if (level >= 13) {
				return "green";
			} else if (level >= 7) {
				return "orange";
			} else {
				return "red";
			}
		},

		// Returns a CSS color string in rgb(,,) form.
		computeBarColor: function (frac) {
			var dark = this.dark_bar_color;
			var light = this.light_bar_color;
			if (this.invert) {
				frac = 1 - frac;
			}
			var color = [
				Math.round(frac * dark[0] + (1 - frac) * light[0]),
				Math.round(frac * dark[1] + (1 - frac) * light[1]),
				Math.round(frac * dark[2] + (1 - frac) * light[2]),
			];
			return "rgb(" + color.join(", ") + ")";
		},

		// Returns whether the update succeeded; the update fails if this view
		// has never been in the DOM and never gotten to compute its size.
		updateBarAndLabel: function () {
			// We have to be in the DOM for these width calls to work.
			// If we aren't, use the last good value.
			this.container_width = this.$el.width() || this.container_width;
			this.label_width = this.$(".alc--label").width() || this.label_width;
			// If we still don't have widths, stop now.
			if (!this.container_width) {
				return false;
			}

			var width_base = 24;
			var percent = this.model.get("xp_percent");
			var bar_width = Math.round(
				width_base + (this.container_width - width_base) * (percent / 100)
			);
			this.$(".alc-xp-bar").width(bar_width + "px");

			var label = this.$(".alc--label");
			if (this.label_width + 3 > bar_width - width_base) {
				label.addClass("alc--outside");
				label.css("right", -this.label_width - 3 + "px");
			} else {
				label.removeClass("alc--outside");
				label.css("right", "3px");
			}
			return true;
		},

		// Detect changes to this element's width by polling.
		monitorWidth: function () {
			var curr_width = this.$el.width();
			if (!curr_width) {
				return;
			}
			if (!this.container_width || curr_width !== this.container_width) {
				this.updateBarAndLabel();
			}
		},

		postRender: function () {
			var ok = this.updateBarAndLabel();
			if (!ok) {
				this.$(".alc-xp-bar").width(0);
				// This call will usually happen once we're in the DOM, which saves on
				// the delay of the setInterval calls below.
				setTimeout(_.bind(this.updateBarAndLabel, this), 10);
			}
			// A variety of things can affect the size of this view, like responsive
			// design, and we need to recompute the dimensions whenever it changes.
			if (!this.monitor_interval) {
				this.monitor_interval = setInterval(
					_.bind(this.monitorWidth, this),
					200
				);
			}

			var color = this.computeBarColor(this.model.get("xp_percent") / 100);
			this.$(".alc-xp-bar").css("background-color", color);

			var AlcDebug = AoPS.Alcumus.Debug;
			if (AlcDebug) {
				this.$(".alc-level-emblem").click(
					_.bind(function () {
						this.invert = !this.invert;
						this.render();
					}, this)
				);
			}
		},

		onClose: function () {
			if (this.monitor_interval) {
				clearInterval(this.monitor_interval);
			}
		},
	});

	// Although this is the subject panel, the model passed in is the user model.
	// The view itself determines what the displayed subject should be.
	AlcVSubject.ProgressPanel = AlcVBase.BaseView.extend({
		initialize: function (options) {
			this.setTemplateAndUseRootEl("alc-tpl-subject-panel");

			this.model.requestLoad(function (ok, data) {
				if (!ok) {
					return this.renderError(data);
				}

				this.listenTo(
					this.model,
					"change:focus_parent change:focus_topic",
					function () {
						this.model.get("current_problem").requestLoad(function () {
							this.resetSubjectModel();
							this.render();
						}, this);
					}
				);
				// Only update the subject bar when user finishes reading the solution.
				this.listenTo(this.model, "show_problem", function () {
					this.resetSubjectModel();
					this.render();
				});

				this.resetSubjectModel();
				this.render();
			}, this);
			this.renderLoading();
		},

		resetSubjectModel: function () {
			var orig_subject_model = this.subject_model;

			if (orig_subject_model) {
				this.stopListening(orig_subject_model, "change");
			}

			// This view is easier to make if we always have a subject model,
			// so guarantee that it will be set. The case of getCurrentSubject
			// returning null should be super rare anyway.
			this.subject_model =
				this.model.getCurrentSubject() ||
				this.subject_model ||
				this.model.get("subjects").first();

			this.listenTo(this.subject_model, "change", this.render);

			if (orig_subject_model !== this.subject_model) {
				this.clearLocation("@xp_bar");
				var view_obj = new AlcVSubject.XpBar({
					model: this.subject_model,
				});
				this.addSubviewToLocation(view_obj, "@xp_bar");
			}
		},

		getContext: function () {
			var subject = this.subject_model;
			var level = parseInt(subject.get("level"), 10);
			return {
				name: subject.get("name"),
				level: level,
				next_level: level ? level + 1 : 0,
				xp_in_level: subject.get("xp_in_level"),
				xp_to_next: subject.get("xp_to_next"),
			};
		},
	});

	return AlcVSubject;
})(AoPS.Alcumus.Views.Subject);
